var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7 12h5m0 0h5m-5 0V7m0 5v5","stroke":"#fff","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.5"}));
}

Plus.defaultProps = {"fill":"none","height":"24","width":"24"};

module.exports = Plus;

Plus.default = Plus;
